module.exports = __webpack_public_path__ + "img/house1.9b033db2.png";